export default __webpack_public_path__ + "static/ef-partner-logo-20e4d3f8cf18e74f31a89008b48f2aa2.png";